export default "__VITE_ASSET__BwEyczz2__"